const RUOLI = { direzione: "Socio", direttore_commerciale: "Direttore", agente: "Agente", segreteria: "Segreteria", buyer: "Buyer" };

export const conRuolo = (u) => `${u.name || "—"}${RUOLI[u.role] ? ` – ${RUOLI[u.role]}` : ""}`;
